import { Tree } from '../types/tree';
import A_ImagePark1 from './assets/tree/A_ImagePark1.jpg';
import A_ImagePark2 from './assets/tree/A_ImagePark2.jpg';
import A_ImagePark3 from './assets/tree/A_ImagePark3.jpg';
import A_ImagePark4 from './assets/tree/A_ImagePark4.jpg';
import A_UserAvatar from '@/assets/images/A_UserAvatar.png';

export const treeMocks: Tree[] = [
  {
    id: '1',
    name: 'Дуб',
    description:
      'Величественный дуб возрастом более 200 лет, расположенный в центральном парке. Это дерево является символом города и нуждается в уходе для сохранения его красоты.',
    image: A_ImagePark1,
    location: 'Центральный парк, Москва',
    latitude: 55.7558,
    longitude: 37.6176,
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-20T14:30:00Z',
    cost: 50000,
    totalDonations: 32000,
    donorsCount: 8,
    donations: [
      {
        id: 'd1',
        userId: 'user1',
        userName: 'Анна Петрова',
        userAvatar: A_UserAvatar,
        amount: 5000,
        donatedAt: '2024-01-16T09:15:00Z',
      },
      {
        id: 'd2',
        userId: 'user2',
        userName: 'Михаил Сидоров',
        userAvatar: A_UserAvatar,
        amount: 3000,
        donatedAt: '2024-01-17T11:20:00Z',
      },
      {
        id: 'd3',
        userId: 'user3',
        userName: 'Елена Козлова',
        userAvatar: A_UserAvatar,
        amount: 8000,
        donatedAt: '2024-01-18T16:45:00Z',
      },
      {
        id: 'd4',
        userId: 'user4',
        userName: 'Дмитрий Волков',
        userAvatar: A_UserAvatar,
        amount: 2000,
        donatedAt: '2024-01-19T13:10:00Z',
      },
      {
        id: 'd5',
        userId: 'user5',
        userName: 'Ольга Морозова',
        userAvatar: A_UserAvatar,
        amount: 4000,
        donatedAt: '2024-01-20T10:30:00Z',
      },
      {
        id: 'd6',
        userId: 'user6',
        userName: 'Сергей Новиков',
        userAvatar: A_UserAvatar,
        amount: 1500,
        donatedAt: '2024-01-20T14:20:00Z',
      },
      {
        id: 'd7',
        userId: 'user7',
        userName: 'Мария Иванова',
        userAvatar: A_UserAvatar,
        amount: 3500,
        donatedAt: '2024-01-20T15:45:00Z',
      },
      {
        id: 'd8',
        userId: 'user8',
        userName: 'Алексей Смирнов',
        userAvatar: A_UserAvatar,
        amount: 5000,
        donatedAt: '2024-01-20T16:30:00Z',
      },
    ],
  },
  {
    id: '2',
    name: 'Берёза',
    description:
      'Красивая липа, которая каждое лето радует жителей района своим ароматным цветением. Требует обрезки и лечения от вредителей.',
    image: A_ImagePark2,
    location: 'Сквер на ул. Пушкина, Санкт-Петербург',
    latitude: 59.9311,
    longitude: 30.3609,
    createdAt: '2024-01-10T08:00:00Z',
    updatedAt: '2024-01-18T12:15:00Z',
    cost: 25000,
    totalDonations: 18000,
    donorsCount: 5,
    donations: [
      {
        id: 'd9',
        userId: 'user9',
        userName: 'Татьяна Соколова',
        userAvatar: A_UserAvatar,
        amount: 6000,
        donatedAt: '2024-01-11T14:20:00Z',
      },
      {
        id: 'd10',
        userId: 'user10',
        userName: 'Владимир Попов',
        userAvatar: A_UserAvatar,
        amount: 4000,
        donatedAt: '2024-01-12T09:30:00Z',
      },
      {
        id: 'd11',
        userId: 'user11',
        userName: 'Наталья Лебедева',
        userAvatar: A_UserAvatar,
        amount: 3000,
        donatedAt: '2024-01-15T11:45:00Z',
      },
      {
        id: 'd12',
        userId: 'user12',
        userName: 'Игорь Комаров',
        userAvatar: A_UserAvatar,
        amount: 2500,
        donatedAt: '2024-01-17T16:10:00Z',
      },
      {
        id: 'd13',
        userId: 'user13',
        userName: 'Юлия Медведева',
        userAvatar: A_UserAvatar,
        amount: 2500,
        donatedAt: '2024-01-18T10:25:00Z',
      },
    ],
  },
  {
    id: '3',
    name: 'Яблоня',
    description:
      'Могучий кедр, посаженный в честь 50-летия города. Нуждается в укреплении корневой системы и защите от городской среды.',
    image: A_ImagePark3,
    location: 'Площадь Победы, Новосибирск',
    latitude: 55.0084,
    longitude: 82.9357,
    createdAt: '2024-01-05T12:00:00Z',
    updatedAt: '2024-01-15T17:45:00Z',
    cost: 75000,
    totalDonations: 45000,
    donorsCount: 12,
    donations: [
      {
        id: 'd14',
        userId: 'user14',
        userName: 'Андрей Федоров',
        userAvatar: A_UserAvatar,
        amount: 10000,
        donatedAt: '2024-01-06T08:30:00Z',
      },
      {
        id: 'd15',
        userId: 'user15',
        userName: 'Екатерина Романова',
        userAvatar: A_UserAvatar,
        amount: 5000,
        donatedAt: '2024-01-07T12:15:00Z',
      },
      {
        id: 'd16',
        userId: 'user16',
        userName: 'Павел Орлов',
        userAvatar: A_UserAvatar,
        amount: 3000,
        donatedAt: '2024-01-08T15:40:00Z',
      },
      {
        id: 'd17',
        userId: 'user17',
        userName: 'Анна Соловьева',
        userAvatar: A_UserAvatar,
        amount: 4000,
        donatedAt: '2024-01-09T10:20:00Z',
      },
      {
        id: 'd18',
        userId: 'user18',
        userName: 'Денис Воробьев',
        userAvatar: A_UserAvatar,
        amount: 2000,
        donatedAt: '2024-01-10T14:50:00Z',
      },
      {
        id: 'd19',
        userId: 'user19',
        userName: 'Людмила Жукова',
        userAvatar: A_UserAvatar,
        amount: 3500,
        donatedAt: '2024-01-11T11:30:00Z',
      },
      {
        id: 'd20',
        userId: 'user20',
        userName: 'Артем Соколов',
        userAvatar: A_UserAvatar,
        amount: 2500,
        donatedAt: '2024-01-12T16:45:00Z',
      },
      {
        id: 'd21',
        userId: 'user21',
        userName: 'Ирина Морозова',
        userAvatar: A_UserAvatar,
        amount: 3000,
        donatedAt: '2024-01-13T09:15:00Z',
      },
      {
        id: 'd22',
        userId: 'user22',
        userName: 'Максим Козлов',
        userAvatar: A_UserAvatar,
        amount: 2000,
        donatedAt: '2024-01-14T13:25:00Z',
      },
      {
        id: 'd23',
        userId: 'user23',
        userName: 'Ольга Новикова',
        userAvatar: A_UserAvatar,
        amount: 4000,
        donatedAt: '2024-01-15T10:40:00Z',
      },
      {
        id: 'd24',
        userId: 'user24',
        userName: 'Сергей Петров',
        userAvatar: A_UserAvatar,
        amount: 3000,
        donatedAt: '2024-01-15T15:20:00Z',
      },
      {
        id: 'd25',
        userId: 'user25',
        userName: 'Марина Сидорова',
        userAvatar: A_UserAvatar,
        amount: 2000,
        donatedAt: '2024-01-15T17:30:00Z',
      },
    ],
  },
  {
    id: '4',
    name: 'Баобаб',
    description:
      'Изящная береза в городском сквере, символ русской природы. Требует лечения от грибковых заболеваний и обрезки сухих веток.',
    image: A_ImagePark4,
    location: 'Сквер Мира, Екатеринбург',
    latitude: 56.8431,
    longitude: 60.6454,
    createdAt: '2024-01-20T09:00:00Z',
    updatedAt: '2024-01-20T09:00:00Z',
    cost: 15000,
    totalDonations: 0,
    donorsCount: 0,
    donations: [],
  },
];
